import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {getCompetitionProgressBars} from './tools.js';
import ga from 'analytics';

import {fetchTimeline} from 'actions/timeline.js';
import {initNavbarState, setNavbarTitle, setNavbarEnable} from 'actions/navbar.js';
import CompetitionContainer from 'modules/challenges/CompetitionContainer.js';
import {NavControl} from 'modules/navigation/NavBarContainer.js';
import {getCard} from 'reducers/cards.js';
import LoadInline from 'modules/loading/LoadInline.js';
import ErrorPage from 'modules/misc/ErrorPage.js';
import Utils from 'utils/Utils.js';
import Challenge from './Challenge.js';
import DatabaseService from 'services/DatabaseService.js';

class SeasonContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {busy: false, 
                      season:null,
                      showCompetitionActivities:false};
        this.onCloseChallenge = this.onCloseChallenge.bind(this);
        this.onCloseCompetition = this.onCloseCompetition.bind(this);
        this.onShowCompetitionActivities = this.onShowCompetitionActivities.bind(this);
        this.onHideCompetitionActivities = this.onHideCompetitionActivities.bind(this);
        this.onLaunchChallenge = this.onLaunchChallenge.bind(this);
    }

    componentWillMount() {
        this.props.initNavBar(this.props.t);
        this.loadData();
    }

    filterSurveyPages(result) {
        if(result && result.survey && result.survey.surveyPages) {
            result.survey.surveyPages = result.survey.surveyPages.filter(this.filterSurveyPage);
        }
        return result;
    }
    filterSurveyPage(surveyPage) {
        if(surveyPage.type===111) {
            return false;
        } else if (surveyPage.type===109) {
            return false;
        }

        return true;
    }

    loadData() {
        this.setState({busy:true});
        DatabaseService.getSeason(this.props.match.params.id)
                            .then(result=>{
                                this.setState({season:result.season});
                            })
                            .catch((error)=>{
                                console.error("Error: ", error);
                                this.setState({error:String(error)});
                            })
                            .then(()=>{
                                this.setState({busy:false});
                            });
    }

    onCloseChallenge() {
        this.setState({selectedChallengeId:null},
            ()=>{
                Utils.popScrollPosition();
            } 
        ); 
        this.props.initNavBar(this.props.t);
        //opening a challenge manually triggers a virtual page because the route has not changed - this tells google-analytics we're back on the page last tracked by urlChangeTracker
        ga('send', 'pageview'); 
    }

    onCloseCompetition() {
        this.props.history.goBack();
    }
    
    onHideCompetitionActivities() {
        this.setState({showCompetitionActivities:false},
            ()=>{
                Utils.popScrollPosition();
            } 
        );
    }

    onLaunchChallenge(challenge) {
        Utils.pushScrollPosition();
        this.setState({selectedChallengeId:challenge.id}); 
    }

    onShowCompetitionActivities() {
        Utils.pushScrollPosition();
        this.setState({showCompetitionActivities:true},
            () => {
                window.scrollTo(0, 0); 
            }
        );
    }

    getUserChallenges() {
        return Object.values(this.results).map(r=>r.userChallenge).filter((uc)=>(uc!=null));
    }



    render() {
        var card = {season:this.state.season};
        if(this.state.error) {
            return (
                    <NavControl onClose={this.props.noClose ? null : this.close} closeIconOpts={this.props.closeIconOpts}>
                        <ErrorPage error={this.state.error} />
                    </NavControl>
                    );
        } else if(this.state.busy) {
            return (
                <NavControl onClose={this.close}>
                    <LoadInline centered vcentered /> 
                </NavControl>
            );
        } else if(this.state.selectedChallengeId) {
            return (
                <NavControl onClose={this.onCloseChallenge}>
                    <Challenge challengeId={this.state.selectedChallengeId} onContinue={this.onCloseChallenge} />
                </NavControl>
            );
        } else {
            return (
                <NavControl onClose={(this.state.showCompetitionActivities||this.props.categories) && !this.props.categories ? this.onHideCompetitionActivities : this.onCloseCompetition}>
                    <CompetitionContainer card={card} 
                                          showCompetitionActivities={this.state.showCompetitionActivities || this.props.categories} 
                                          getCompetitionProgressBars={this.getCompetitionProgressBars}
                                          onShowCompetitionActivities={this.onShowCompetitionActivities}
                                          onLaunchChallenge={this.onLaunchChallenge} />
                </NavControl>
            );
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
}

const mapDispatchToProps = (dispatch) => {
    return {
        initNavBar: (t) => dispatch(initNavbarState({enable:true, menuEnable:true, backButtonEnable:false, rewardsEnable:true, mode: 'main'})),
        dispatch: dispatch
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SeasonContainer));



// WEBPACK FOOTER //
// ./src/modules/challenges/SeasonContainer.js